import React from "react";
import Admin from "components/admin/admin";
import BrandApplication from "components/brands/brand-application";
import BrandInvite from "components/brands/brand-invite";
import ExternalBrandAcceptPage from "components/external-brand-accept/ExternalBrandAcceptPage";
import BrandMessage from "components/brands/brand-message";
import Builder from "components/campaigns/builder/builder-container";
import NewCampaign from "components/campaigns/new_campaign/new-campaign-container";
import NewSoloSweepstakes from "components/campaigns/new_campaign/new-solo-sweepstakes-container";
import CustomerSuccessAdmin from "components/cs-admin/customer-success-admin-container";
import DataAdmin from "components/data-admin/data-admin-container";
import PreferredTermsPlanModal from "components/insert-payment-info/preferred-terms-plan-modal";
import SoftEntriesPaywallModal from "components/insert-payment-info/soft-entries-paywall";
import TrialExtendedModal from "components/insert-payment-info/trial-extended-modal";
import PartnershipsCalendar from "components/partnerships/PartnershipsCalendarContainer";
import EliteRequest from "components/pricing/elite-request";
import UpgradePlan from "components/pricing/upgrade-plan";
import QualityAssuranceAdmin from "components/qa-admin/quality-assurance-admin-container";
import RegisterBrandProfile from "components/registration/brand-profile";
import RegisterBrandProfileInterests from "components/registration/brand-profile-interests";
import RegisterBrandSetup from "components/registration/brand-setup";
import PlatformInviteModal from "components/search_brands/platform-invite-modal";
import PlatformInviteSuccessModal from "components/search_brands/platform-invite-success-modal";
import CheckNewVersion from "container-components/CheckNewVersion";
import { Redirect, Route, Switch } from "react-router-dom";
import ConfirmationModal from "util/components/confirmation-modal";
import NotEnoughEntriesModal from "util/components/not-enough-entries";
import ReviewPartnershipAgreement from "v2/components/partnership_agreement/ReviewPartnershipAgreement";
import MediaReviewsModal from "visual-components/brandProfile/brand-reviews/MediaReviewsModal";
import MediaReviewsPage from "visual-components/brandProfile/brand-reviews/MediaReviewsPage";
import BrandCcpaRequest from "visual-components/ccpaRequest/brand-ccpa-request";
import CcpaRequest from "visual-components/ccpaRequest/ccpa-request";
import AcceptApplicationConfirmationModal from "visual-components/messaging/messaging-accept-application-confirmation-modal";
import AcceptInviteConfirmationModal from "visual-components/messaging/messaging-accept-invite-confirmation-modal";
import AcceptPartnershipModal from "visual-components/messaging/messaging-accept-partnership-modal";
import DeclinePartnershipModal from "visual-components/messaging/messaging-decline-partnership-modal";
// TODO (Jenky): Disabled (10/25/2022) until we have people back on sales
// import CalendlyModal from 'components/notifications/calendly-modal';
import MessagingLimitPartnersModal from "visual-components/messaging/messaging-limit-partners";
import SMSCheckoutModal from "visual-components/mobile-marketing/modals/SMSCheckoutModal";
import SMSPurchaseSuccessModal from "visual-components/mobile-marketing/modals/SMSPurchaseSuccessModal";
import MyPartnerships from "visual-components/myPartnerships/MyPartnerships";
import SocialActionsPurchaseSuccess from "visual-components/myPartnerships/social-actions-purchase-success";
import InternalNavBar from "visual-components/navBar/InternalNavBar";
// payments
import PaymentReceivedFullModal from "visual-components/payments/payment-received-full-modal";
import UpgradePlanFullModal from "visual-components/payments/upgrade-plan-full-modal";
import ROICalculator from "visual-components/roi_calculator";
import Splash from "visual-components/splash/Splash";
/* static */
import NotFound from "visual-components/static/NotFound";
import ContactSupportModal from "visual-components/util/modals/contact-support-modal";
// TODO (Jenky): Disabled (10/25/2022) until we have people back on sales
// import CallOffer from 'components/registration/call-offer';
import InterestedInLearnMoreModal from "visual-components/util/modals/interested-in-learn-more-modal";
import NewUserReferredCampaignModal from "visual-components/util/modals/new-user-referred-campaign-modal";
import PricingGateModal from "visual-components/util/modals/pricing-gate-modal";
import ReferralProgramReminderDialog from "visual-components/util/modals/referral-program-reminder-dialog";
import versionJson from "../../version.json";
import CurrentTaskModal from "../app/visual-components/myPartnerships/createTasks/current-task-modal";
import DeleteTaskConfirmationDialog from "../app/visual-components/myPartnerships/createTasks/delete-task-confirmation-dialog";
import SocialActionsPurchaseModal from "../app/visual-components/myPartnerships/social-actions-purchase-modal";
import Login from "./components/Login";
import Analytics from "./components/analytics/Analytics";
import BrandLogoRequiredModal from "./components/brands/BrandLogoRequiredModal";
import Explore from "./components/explore/Explore";
import Messaging from "./components/messaging/Messaging";
import Notifications from "./components/notifications/Notifications";
import CreateOpportunityModal from "./components/opportunities/create-opportunity-modal";
import Profile from "./components/profile/Profile";
// import InviteBannerContainer from "./components/util/InviteBanner/InviteBannerContainer";
import LiveNotifications from "./components/util/LiveNotifications";
import QuestCollapse from "./components/util/QuestCollapse/QuestCollapse";
/* modals */
import QuestCompleteModal from "./components/util/QuestCollapse/quest-complete-modal";
import ErrorBoundary from "./error-boundary";
import App from "./v2-app";

const { version } = versionJson;

const routes = [
  {
    label: "Discover",
    to: "/search",
    exact: true,
    overrideHref: "/app/search",
  },
  {
    label: "Sweepstakes",
    to: "/sweepstakes",
    overrideHref: "/app/sweepstakes",
  },
];

const BrandSwitcher = ({
  match: {
    params: { brandId, userId },
  },
  location: { state },
}) => {
  try {
    sessionStorage.setItem(userId, brandId);
  } catch (e) {
    console.error("sessionStorage unavailable");
  }
  return <Redirect to={(state && state.to) || "/"} />;
};

const bannerAvoidRoutes = [
  "calculate-roi",
  "upgrade-plan",
  "upgrade-payment-confirm/",
  "upgrade-success/",
];

const redirectToFuture = ({ location }) => {
  window.location.replace(`/app${location.pathname}`);
  return null;
};

const Routes = (
  <ErrorBoundary>
    <CheckNewVersion currentVersion={version} />
    <Switch>
      <Route exact path="/login" component={Login} />
      <Route exact path="/ccpa-request" component={CcpaRequest} />
      <Route path="/external-brand-accept/:code" component={ExternalBrandAcceptPage} />
      <Route exact path="/switch/:brandId/:userId" render={BrandSwitcher} />
      <Route path="/missing-payment" component={UpgradePlanFullModal} />
      <Route path="/registrations/brand-setup/:referralId?" component={RegisterBrandSetup} />
      <Route path="/registrations/brand-profile" component={RegisterBrandProfile} />
      <Route
        path="/registrations/brand-profile-interests"
        component={RegisterBrandProfileInterests}
      />
      {/* TODO (Jenky): Disabled (10/25/2022) until we have people back on sales */}
      {/* <Route path="/registrations/call-offer" component={ CallOffer } /> */}
      <Route path="/new-splash" component={Splash} />
      <Route
        render={(routeProps) => (
          <App>
            <InternalNavBar routes={routes} {...routeProps} />
            <ErrorBoundary>
              <LiveNotifications />
              <QuestCollapse avoidRoutes={bannerAvoidRoutes} />
              <Route path="/explore/(campaigns|brands)/:id" render={redirectToFuture} />
              <Switch>
                <Route path="/admin" component={Admin} />
                <Route exact path="/brand-ccpa-request" component={BrandCcpaRequest} />
                <Route
                  path="/builder/:campaignId/:section/:subSection?/:partnershipId?"
                  component={Builder}
                />
                <Route path="/analytics" component={Analytics} />
                <Route path="/calculate-roi" component={ROICalculator} />
                <Route path="/cs-admin/:section?" component={CustomerSuccessAdmin} />
                <Route path="/calendar" component={PartnershipsCalendar} />
                <Route path="/data-admin" component={DataAdmin} />
                <Route path="/elite-request" component={EliteRequest} />
                <Route path="/explore" component={Explore} />
                <Route path="/messaging" component={Messaging} />
                <Route path="/notifications" component={Notifications} />
                <Route path="/new-campaign" component={NewCampaign} />
                <Route path="/new-solo-sweepstakes" component={NewSoloSweepstakes} />
                <Route
                  path="/partnerships/purchase-social-actions"
                  component={SocialActionsPurchaseModal}
                />
                <Route path="/partnerships" component={MyPartnerships} />
                <Route
                  path="/partnership-agreement/:partnershipId"
                  component={ReviewPartnershipAgreement}
                />
                <Route path="/profile" component={Profile} />
                {process.env.SENTRY_ENV !== "production" && (
                  <Route path="/qa-admin" component={QualityAssuranceAdmin} />
                )}
                <Route path="/reviews" component={MediaReviewsPage} />
                <Route
                  path="/social-action-purchase-success"
                  component={SocialActionsPurchaseSuccess}
                />
                <Route path="/upgrade-plan" component={UpgradePlan} />
                <Route path="/upgrade-success/:belt" component={PaymentReceivedFullModal} />
                <Route path="/upgrade-trial-confirm/:belt" component={UpgradePlanFullModal} />
                <Route path="/upgrade-payment-confirm/:belt" component={UpgradePlanFullModal} />
                <Route path="/manage-sms-marketing" component={SMSCheckoutModal} />
                <Route path="/sms-marketing-purchase-success" component={SMSPurchaseSuccessModal} />
                <Route path="/404" component={NotFound} />
                <Route component={NotFound} />
              </Switch>
              <BrandMessage />
              <BrandApplication />
              <InterestedInLearnMoreModal />
              <PricingGateModal />
              <ContactSupportModal />
              <ConfirmationModal />
              <NotEnoughEntriesModal />
              <TrialExtendedModal />
              <PreferredTermsPlanModal />
              {/* TODO (Jenky): Disabled (10/25/2022) until we have people back on sales */}
              {/* <CalendlyModal /> */}
              <SoftEntriesPaywallModal />
              <BrandApplication />
              <BrandInvite />
              <QuestCompleteModal />
              <AcceptInviteConfirmationModal />
              <AcceptApplicationConfirmationModal />
              <AcceptPartnershipModal />
              <DeclinePartnershipModal />
              <NewUserReferredCampaignModal />
              <BrandLogoRequiredModal />
              <MessagingLimitPartnersModal />
              <ReferralProgramReminderDialog />

              <CurrentTaskModal />
              <DeleteTaskConfirmationDialog />
              <CreateOpportunityModal />
              {/* TODO: Check how to set priority in these modals */}
              <MediaReviewsModal />
              <PlatformInviteModal />
              <PlatformInviteSuccessModal />
            </ErrorBoundary>
          </App>
        )}
      />
    </Switch>
  </ErrorBoundary>
);

export default Routes;
